<div class="modal-header">
  <button
    type="button"
    class="cy-modal-close"
    (click)="dismiss()"
    aria-label="Cerrar modal">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>
  @if(data?.title) {
    <h3>{{ data?.title }}</h3>
  }
</div>
<div class="modal-content">
  <div>
    @if (data?.image) {
      <img [src]="data.image" class="max-w-full block">
    }
    @if (data?.description) {
      <div [innerHTML]="data.description | safeHtml"></div>
    }
  </div>
  <div class="modal-actions">
    <button (click)="cancel()" class="btn btn_primary btn_outline">Cerrar</button>
    @if(data) {
      @if(data.type && data.type === 'download-app') {
        @if(xServices.isAppleDevice()) {
          <a href="{{ url }}" target="_blank" class="btn_img">
            <img src="/assets/icons/DownloadAppStore.svg" />
          </a>
        } @else {
          <a href="{{ url }}" target="_blank" class="btn_img">
            <img src="/assets/icons/GetItOnGooglePlay.svg" />
          </a>
        }
      } @else {
        @if (url) {
          @if(data.redirect_type && data.redirect_type === 'external') {
            <a href="{{ url }}" target="_blank" class="btn btn_primary">{{ data.button_name ?? 'Aceptar' }}</a>
          } @else {
            <a routerLink="{{ url }}" class="btn btn_primary">{{ data.button_name ?? 'Aceptar' }}</a>
          }
        }
      }
    }
  </div>
</div>

<style>
  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 1rem;
  }

  .spinner {
    border: 4px solid rgba(0, 0, 0, 0.1);
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border-left-color: var(--primary-color, #3f51b5);
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .no-tickets-message {
    text-align: center;
    padding: 1rem;
    color: #666;
  }
</style>
